// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"0c9c1325","63":"13b3dcf8","119":"7425a347","279":"0122df23","373":"0a1aae77","431":"12793ff3","452":"91993801","571":"19d1cbef","679":"54631763","774":"251132ad","951":"81ce60f2"}[chunkId] + ".chunk.js";
};